import React, { useEffect } from 'react';
import { ExternalLink, BookOpen } from 'lucide-react';

const Books = () => {
  useEffect(() => {
    document.title = 'Kitaplar | Banu Gökcül - akarma';
  }, []);

  const books = [
    {
      title: 'Süper Beynin Sırları',
      year: '2019',
      image: 'https://akarma.com.tr/images/super-beynin-sirlari-banu-gokcul.jpg',
      description: 'Sizi engelleyen her şeyden şimdi jet hızıyla kurtulun! Ağrılar, korkular, kaygılar, yetersizlik, değersizlik, suçluluk, aşk acısı, panik atak...',
      quote: '"Bazı kitaplar okunmak, bazıları ise yaşanmak için yazılmıştır. Süper Beynin Sırları kitabını herkesin yaşamının parçası haline getirmesini ve yaşamına uyarlamasını diliyorum. Bu sayede o hep özlediğimiz, daha iyi bir hayat ve daha iyi bir dünya arzusuna doğru büyük bir adım atmış olacağız." - Prof. Dr. Sinan Canan, Neuroscientist Üsküdar Üniversitesi',
      buyLink: 'https://www.alfakitap.com/kitap.php?id=375728'
    },
    {
      title: 'Stratejik İlişki Kurma: MÜZAKERE',
      year: '2015',
      image: 'https://akarma.com.tr/images/stratejik-iliski-kurma-banu-gokcul-kitap.jpg',
      description: 'İşte, evde, satışta... İstediğiniz sonuçları elde etmek istiyorsunuz. Tek yapmanız gereken bu kitaptaki mükemmel ipuçlarını uygulamak.',
      reviews: [
        '"Bu kitap konuşmanın gücünü harekete geçiriyor. Mutlaka okunmalı. İnsanlar üzerinde kendi etkinişi fark edeceksiniz." - Veyis Ateş, Habertürk',
        '"Patronların Koçu... Patronların kılavuz kaptanı, başarılı Müzakere\'nin sırlarını açıklıyor." - Para',
        '"Karizma ve Liderlik becerileri geliştirme konusunda Türkiye\'nin en başarılı mentoru." - Fortune Dergisi'
      ],
      buyLink: 'https://www.alfakitap.com/kitap.php?id=9593'
    },
    {
      title: 'Gözler Üzerindeyken Başarmak: SUNUM',
      year: '2012',
      image: 'https://akarma.com.tr/images/gozler-uzerindeyken-basarmak-sunum-banu-gokcul.jpg',
      description: 'Okul ve iş hayatımız boyunca sürekli olarak sunum yapmak zorunda kalıyoruz. Özellikle son dönemde eğitim sistemi bizi gerçek hayatta karşılaşacağımıza karşı daha hazırlıklı hale getirmeye başladığı için sınav yerine sunum yapma alışkanlığı hızla yerleşiyor.',
      features: [
        'Etkili sunum yapabilme becerileri',
        'Hem sunum yapacak kişi için eğlenceli bilgiler',
        'Katılımı artıracak teknikler',
        'Dinlemeyi kolaylaştıracak yöntemler',
        'Gerekli etkiyi yaratmak için beceriler'
      ],
      buyLink: 'https://www.alfakitap.com/kitap.php?id=235084'
    },
    {
      title: 'Farkındalığın Şifresi',
      year: '2009',
      image: 'https://akarma.com.tr/images/farkindaligin-sifresi-banu-gokcul.jpg',
      description: 'Bu kitap, her nefes alma anımızın farkına varmamızı, ayılmamızı ve kendimize oynadığımız tüm oyunlardan, kandırmacalardan kendimizi sıyırmamızı sağlamak ve sadece kendi kendininzin efendisi olabilmeniz amacı ile yazılmıştır.',
      topics: [
        'Kim olduğumuzu biliyor muyuz?',
        'Ne istediğimizin farkında mıyız?',
        'Seçeneklerimizi görebiliyor muyuz?',
        'Seçimlerimizi ne kadar denetleyebiliyoruz?',
        'Bizi harekete geçiren, durduran ya da engelleyen şeyleri fark edebiliyor muyuz?'
      ],
      buyLink: 'https://www.alfakitap.com/kitap.php?id=248727'
    }
  ];

  return (
    <div className="books pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <BookOpen size={64} className="mx-auto mb-6" />
            <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in">Kitaplar</h1>
            <p className="text-xl md:text-2xl opacity-90">
              Liderlik Kitapları Serisi - Alfa ve Kapital Yayıncılık
            </p>
          </div>
        </div>
      </section>

      {/* Books List */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="space-y-24">
            {books.map((book, index) => {
              const isEven = index % 2 === 0;
              
              return (
                <div key={index} className="fade-in">
                  <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-start`}>
                    <div className={`${!isEven ? 'lg:order-2' : ''}`}>
                      <div className="bg-white p-4 rounded-2xl shadow-2xl card-hover">
                        <img
                          src={book.image}
                          alt={book.title}
                          className="w-full h-[600px] object-contain rounded-lg"
                        />
                      </div>
                    </div>

                    <div className={`${!isEven ? 'lg:order-1' : ''} space-y-6`}>
                      <div>
                        <div className="inline-block px-4 py-2 bg-blue-100 text-akarma-blue rounded-full font-semibold mb-4">
                          {book.year}
                        </div>
                        <h2 className="text-4xl font-bold mb-4">{book.title}</h2>
                      </div>

                      <p className="text-lg text-gray-700 leading-relaxed">
                        {book.description}
                      </p>

                      {book.quote && (
                        <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl border-l-4 border-akarma-blue">
                          <p className="text-gray-700 italic">{book.quote}</p>
                        </div>
                      )}

                      {book.reviews && (
                        <div className="space-y-3">
                          {book.reviews.map((review, idx) => (
                            <div key={idx} className="bg-gray-50 p-4 rounded-lg">
                              <p className="text-gray-700 italic">{review}</p>
                            </div>
                          ))}
                        </div>
                      )}

                      {book.features && (
                        <div className="space-y-2">
                          <h3 className="text-xl font-bold mb-3">Kitapta Bulacaklarınız:</h3>
                          {book.features.map((feature, idx) => (
                            <div key={idx} className="flex items-start space-x-3">
                              <div className="w-2 h-2 bg-akarma-blue rounded-full mt-2 flex-shrink-0"></div>
                              <p className="text-gray-700">{feature}</p>
                            </div>
                          ))}
                        </div>
                      )}

                      {book.topics && (
                        <div className="space-y-2">
                          <h3 className="text-xl font-bold mb-3">Kitapta Yanıt Bulacağınız Sorular:</h3>
                          {book.topics.map((topic, idx) => (
                            <div key={idx} className="flex items-start space-x-3">
                              <div className="w-2 h-2 bg-purple-600 rounded-full mt-2 flex-shrink-0"></div>
                              <p className="text-gray-700">{topic}</p>
                            </div>
                          ))}
                        </div>
                      )}

                      <a
                        href={book.buyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
                      >
                        Şimdi Satın Al
                        <ExternalLink size={20} className="ml-2" />
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional Info */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl text-center">
              <BookOpen size={48} className="mx-auto mb-6 text-akarma-blue" />
              <h2 className="text-3xl font-bold mb-4">BFT Beyin Frekans Teknolojisi CD'leri</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                BFT Beyin Frekans Teknolojisi ile hazırlanmış 100'e yakın Olumlama ve Telkin CD'leri 
                D&R mağazalarında ve www.alfafrekans.com internet sitesinde satılmaktadır.
              </p>
              <a
                href="https://www.alfafrekans.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
              >
                Alfa Frekans'a Git
                <ExternalLink size={20} className="ml-2" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold text-akarma-blue mb-2">4</div>
              <div className="text-xl text-gray-700">Yayınlanmış Kitap</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-purple-600 mb-2">100+</div>
              <div className="text-xl text-gray-700">Makale</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-akarma-blue mb-2">100+</div>
              <div className="text-xl text-gray-700">BFT CD'leri</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Books;